import { render, staticRenderFns } from "./XFormTextArea.vue?vue&type=template&id=0a34104a&"
import script from "./XFormTextArea.vue?vue&type=script&lang=js&"
export * from "./XFormTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports